function makeCancelable(promise) {
    let hasCanceled = false;

    const wrappedPromise = new Promise((resolve, reject) => {
        promise.then(
            // eslint-disable-next-line prefer-promise-reject-errors
            val => (hasCanceled ? reject({ canceled: true }) : resolve(val)),
            // eslint-disable-next-line prefer-promise-reject-errors
            error => (hasCanceled ? reject({ canceled: true }) : reject(error)),
        );
    });

    return {
        promise: wrappedPromise,
        cancel() {
            hasCanceled = true;
            if (Object.prototype.hasOwnProperty.call(promise, 'cancellationTokenSource')) {
                promise.cancellationTokenSource.cancel('canceled');
            }
        },
    };
}

export default makeCancelable;
